
import { defineComponent } from 'vue';
import { pagination } from '@/shared/helpers';

export default defineComponent({
  name: 'AppPagination',
  emits: ['loadPage'],
  props: {
    currentPage: {
      type: Number,
      required: true,
    },

    pageSize: {
      type: Number,
      required: true,
    },

    currentCount: {
      type: Number,
      required: true,
    },

    totalCount: {
      type: Number,
      required: true,
    },

    dots: {
      type: String,
      default: '...',
    },

    simple: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    pageCount() {
      return Math.ceil(this.totalCount / this.pageSize) || 0;
    },

    isPreviousButtonDisabled() {
      return this.currentPage === 1;
    },

    isNextButtonDisabled() {
      return this.currentPage === (this as any).pageCount;
    },

    paginationTriggers() {
      const paginations = pagination(this.currentPage, this.pageCount, this.dots);
      return paginations;
    },
  },

  methods: {
    nextPage() {
      this.$emit('loadPage', this.currentPage + 1);
    },

    onLoadPage(value: number) {
      this.$emit('loadPage', value);
    },

    previousPage() {
      this.$emit('loadPage', this.currentPage - 1);
    },
  },
});
